export { default } from './IntakeDuplicateBadge';
